module.exports = __webpack_public_path__ + "static/media/narrow.bd7b4f19.jpg";